// 表情与开关选项相关的常量

// 表情列表（emoji -> 英文标识）
export const emotionList = [
  {"😶": "neutral"},
  {"🙂": "happy"},
  {"😆": "laughing"},
  {"😂": "funny"},
  {"😔": "sad"},
  {"😠": "angry"},
  {"😭": "crying"},
  {"😍": "loving"},
  {"😳": "embarrassed"},
  {"😲": "surprised"},
  {"😱": "shocked"},
  {"🤔": "thinking"},
  {"😉": "winking"},
  {"😎": "cool"},
  {"😌": "relaxed"},
  {"🤤": "delicious"},
  {"😘": "kissy"},
  {"😏": "confident"},
  {"😴": "sleepy"},
  {"😜": "silly"},
  {"🙄": "confused"},
  //
  {"👄": "mouth"},
  {"👁️": "eye"},
]

// 表情下拉选项
export const emotionOptions = emotionList.map(e => {
  const emoji = Object.keys(e)[0]
  const label = emoji + ' ' + e[emoji]
  return {emoji, label, text: e[emoji]}
})

// 表情状态选项
export const emotionStateOptions = [
  { label: '开启', value: true },
  { label: '关闭', value: false }
]

// 背景动作状态选项
export const backgroundActionStateOptions = [
  { label: '开启', value: true },
  { label: '关闭', value: false }
]
